const Event = require('./lib/eventemitter3');
let event = new Event();
module.exports = event;
